import { module } from 'modujs'

export default class extends module {
  constructor(m) {
    super(m)

    this.events = { click: { closeModal: 'closeModal' } }
  }

  init() {
    this.form = this.el.querySelector('form')
    this.formWrapper = this.el.querySelector('.wpcf7')
    this.successModal = this.el.querySelector('.success-modal')

    this.setFormHiddenFields()
    this.setFileInputHandler()
    this.prepareSentEvent()
  }

  setFormHiddenFields() {
    const jobOfferNameEl = this.form?.querySelector('[name="job-offer-name"]')
    const jobOfferUrlEl = this.form?.querySelector('[name="job-offer-url"]')
    const jobOfferIdEl = this.form?.querySelector('[name="job-offer-id"]')

    if (jobOfferNameEl) {
      jobOfferNameEl.value = this.el.dataset.postTitle
    }

    if (jobOfferUrlEl) {
      jobOfferUrlEl.value = this.el.dataset.postUrl || window.location.href
    }

    if (jobOfferIdEl) {
      jobOfferIdEl.value = this.el.dataset.postId
    }
  }

  setFileInputHandler() {
    this.fileInputEl = this.form?.querySelector('.wpcf7-file')
    this.fileLabelEl = this.form?.querySelector('.file-label')
    this.fileDetailsEl = this.form?.querySelector('.file-details')
    this.fileControlsEl = this.form?.querySelector('.file-controls')
    this.clearFileBtnEl = this.form?.querySelector('.clear-file-btn')

    this.onKeyDownLabel = this.onKeyDownLabel.bind(this)
    this.onClickLabel = this.onClickLabel.bind(this)
    this.onChangeFileInput = this.onChangeFileInput.bind(this)
    this.onClickClearBtn = this.onClickClearBtn.bind(this)

    this.fileLabelEl?.addEventListener('keydown', this.onKeyDownLabel)
    this.fileLabelEl?.addEventListener('click', this.onClickLabel)
    this.fileInputEl?.addEventListener('change', this.onChangeFileInput)
    this.clearFileBtnEl?.addEventListener('click', this.onClickClearBtn)
  }

  onKeyDownLabel(e) {
    if (e.keyCode === 13 || e.keyCode === 32) {
      this.fileInputEl?.focus()
    }
  }

  onClickLabel() {
    this.fileInputEl?.focus()

    return false
  }

  onChangeFileInput() {
    const file = this.fileInputEl?.files?.[0]

    if (this.fileDetailsEl) {
      this.fileDetailsEl.textContent = file
        ? file.name
        : ''
    }

    this.fileControlsEl?.classList.toggle('filled', !!file)
  }

  onClickClearBtn(e) {
    e.preventDefault()

    if (this.fileInputEl)
      this.fileInputEl.value = null
    this.onChangeFileInput()
    this.fileInputEl?.focus()
  }

  prepareSentEvent() {
    this.onFormSent = this.onFormSent.bind(this)

    this.formWrapper?.addEventListener('wpcf7mailsent', this.onFormSent)
  }

  onFormSent() {
    this.successModal?.classList.add('visible')
  }

  closeModal() {
    this.onChangeFileInput()

    this.successModal?.classList.remove('visible')
  }

  destroy() {
    this.fileLabelEl?.removeEventListener('keydown', this.onKeyDownLabel)
    this.fileLabelEl?.removeEventListener('click', this.onClickLabel)
    this.fileInputEl?.removeEventListener('change', this.onChangeFileInput)
    this.clearFileBtnEl?.removeEventListener('click', this.onClickClearBtn)
    this.formWrapper?.removeEventListener('wpcf7mailsent', this.onFormSent)
  }
}
